<template>
    <ul class="c-pagination">
        <li class="c-pagination__link">
            <button class="c-pagination__link__prev" @click="decrement(1)" :disabled="currentPage === 1" :aria-label="$t('interactiveMap.pagination.first', { total: totalPages })">
                <ChevronDouble />
            </button>
        </li>
        <li class="c-pagination__link is-active">
            <button class="prev page-numbers" @click="decrement()" :disabled="currentPage === 1" :aria-label="$t('interactiveMap.pagination.prev', { courante: currentPage - 1, total: totalPages })">
                <Chevron />
            </button>
        </li>
        <li class="c-pagination__link is-active"><span aria-current="page" class="page-numbers current">{{ currentPage }} / {{ totalPages }}</span></li>
        <li class="c-pagination__link is-active">
            <button class="next page-numbers" @click="increment()" :disabled="currentPage === totalPages" :aria-label="$t('interactiveMap.pagination.next', { courante: currentPage + 1, total: totalPages })">
                <Chevron />
            </button>
        </li>
        <li class="c-pagination__link">
            <button class="c-pagination__link__next" @click="increment(totalPages)" :disabled="currentPage === totalPages" :aria-label="$t('interactiveMap.pagination.last', { total: totalPages })">
                <ChevronDouble />
            </button>
        </li>
    </ul>
</template>

<script>
    import ChevronDouble from './icons/PaginationLast.vue';
    import Chevron from './icons/PaginationNext.vue';

    export default {
        name: 'Pagination',
        components: { 
            Chevron,
            ChevronDouble
        },
        props: {
            currentPage: {
                type: Number,
                default: 0
            },
            totalPages: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                scrollOffset: `${Store.components.navigation.obj.height}`
            }
        },
        computed: { },
        methods: {
            increment(page) {
                this.$emit('increment', page);
                window.Store.scrollbar.scrollTo(window.Store.app.theBody.querySelector('#interactive-map'), this.scrollOffset);
            },
            decrement(page) {
                this.$emit('decrement', page);
                window.Store.scrollbar.scrollTo(window.Store.app.theBody.querySelector('#interactive-map'), this.scrollOffset);
            }
        }
    }
</script>